module.exports = __webpack_public_path__ + "img/file_cabinet.6f1052a8.jpg";